"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var index_1 = __importDefault(require("./index"));
exports.default = {
  ADVANCED_CONVO_SETTINGS_URL: "".concat(index_1.default.BASE_URL, "/settings2/conversations/advanced"),
  DOWNLOAD_URL: 'https://help.salesloft.com/s/article/Drift-Desktop',
  MANAGER_TRAINING_URL: 'https://drift-prod-desktop-installers.s3.amazonaws.com/mac/training.pdf',
  SETTINGS_WEB_URL: "".concat(index_1.default.BASE_URL, "/settings2"),
  TROUBLESHOOTING_URL: 'https://help.salesloft.com/s/article/How-To-Troubleshoot-the-Drift-Desktop-App',
  TUTORIAL_VIDEO_URL: 'https://drift-5.wistia.com/medias/jfm6mhm94r'
};